import { create } from 'zustand';
import { useAuthStore } from './authStore';

// Migrate from old localStorage key
const _oldValue = localStorage.getItem('wanderlust_user');
if (_oldValue !== null) {
  localStorage.setItem('poi_planner_user', _oldValue);
  localStorage.removeItem('wanderlust_user');
}

interface UserState {
  displayName: string | null;
  setDisplayName: (name: string) => void;
  getDisplayName: () => string;
  getAuthUserId: () => string | null;
}

export const useUserStore = create<UserState>((set, get) => ({
  displayName: localStorage.getItem('poi_planner_user') || null,

  setDisplayName: (name: string) => {
    localStorage.setItem('poi_planner_user', name);
    set({ displayName: name });
  },

  /**
   * Get display name for changelog, preferring Clerk auth over localStorage.
   */
  getDisplayName: () => {
    const authUser = useAuthStore.getState().user;

    // Prefer Clerk auth email
    if (authUser) {
      return authUser.email || 'User';
    }

    // Fallback to localStorage
    return get().displayName || 'User';
  },

  /**
   * Get authenticated user ID from Clerk auth.
   */
  getAuthUserId: () => {
    const authUser = useAuthStore.getState().user;
    return authUser?.id || null;
  },
}));
